/*
 * @Author: zhaozhuo
 * @Date: 2022-02-18 11:54:58
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-09-16 14:39:31
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\store\recruit\state.js
 */
import * as STATETYPES from '../stateTypes'
const state = {
	// 招募表单
	[STATETYPES.RECRUITFORM]: {}
}
export default state